<template>
  <v-tooltip v-if="isSchubladentarif"
             top
             nudge-bottom="8">
    <template v-slot:activator="{on}">
      <div class="dmb-form-text warning--text"
           v-on="on">
        {{ sbForDisplay }}&nbsp;€
      </div>
    </template>
    <span class="caption">Schubladentarif</span>
  </v-tooltip>
  <div v-else
       class="dmb-form-text primary--text">
    {{ sbForDisplay }}&nbsp;€
  </div>
</template>

<script>
export default {
  name: "VermieterSb",
  props: {
    sb: {
      type: String, // expected format SBxxx, e.g. "SB300"
      required: true
    }
  },
  computed: {
    sbForDisplay() {
      return this.sb.slice(2);
    },
    isSchubladentarif() {
      return this.sb === "SB500";
    }
  }
};
</script>

